import React from 'react'

import simpleFormat from 'src/utils/simpleFormat'

const ThankYouMessage = ({ i18n, beneficiary, removeProfileLink }) => {
  const message = i18n.t('thankyou.message') || (() => {
    const messages = [ i18n.t('thankyou.message1') ]
    if (beneficiary.type == 'Organization' && beneficiary.id != '_multiple'
        && !removeProfileLink)
      messages.push(i18n.t('thankyou.message2'))
    return messages.join(' ')
  })()

  const messageHtml =
    simpleFormat(message)
    .replace('%{link}',
      beneficiary.website_url && !removeProfileLink
      ? `<a href="${beneficiary.website_url}" target="_blank">${
          beneficiary.name.trim()}</a>`
      : beneficiary.name
    )

  return (
    <div className="thankyou-message"
      dangerouslySetInnerHTML={{ __html: messageHtml }} />
  )
}

export default ThankYouMessage
